module.exports = __webpack_public_path__ + "static/media/HomeCare_Logo.e28abaf3.svg";